import { transitionTo } from '../../utils/transitions'

/**
 * Drop-in replacement for React Router <Link> that plays the page transition
 * animation before navigating. Forwards all other props to the <a> element.
 */
export default function TransitionLink({ to, children, onClick, ...rest }) {
  const handleClick = (e) => {
    e.preventDefault()
    if (onClick) onClick(e)
    transitionTo(to)
  }

  return (
    <a href={to} onClick={handleClick} {...rest}>
      {children}
    </a>
  )
}
